const experiences = [
  {
    role: "Data and Machine Learning Engineer",
    company: "Compass Data & AI",
    location: "Toronto, ON",
    period: "May – Aug 2026",
    points: [
      "Extended a dbt recommendation pipeline responsible for over $80M in profit to three new business sectors, moving the eligibility rules into shared, config-driven SQL models with data quality tests",
      "Forecast weekly sales for each sector with a matrix factorization model, scheduled it as Airflow pipelines on AWS, and set up alerts that flag when accuracy starts to drift",
    ],
    links: [],
  },
  {
    role: "Machine Learning Researcher",
    company: "The Hospital for Sick Children",
    location: "Toronto, ON",
    period: "Sep – Dec 2025",
    points: [
      "Built an ensemble model that predicts paediatric stroke outcomes from three sources at once: MRI scans, clinical notes, and structured health records",
      "Wrote the MRI preprocessing pipeline, covering format conversion, skull stripping, normalization, and lesion segmentation, and trained the model on the hospital's GPU cluster",
    ],
    links: [],
  },
  {
    role: "Undergraduate Research Assistant",
    company: "University of Waterloo — Motion Research Lab",
    location: "Waterloo, ON",
    period: "May – Aug 2025",
    points: [
      "Collected a dataset of knee flexion and extension with Vicon motion capture and surface EMG, recording movement and muscle signals side by side",
      "Trained a recurrent network to predict muscle activation from motion alone, focusing on the rectus femoris",
    ],
    links: [],
  },
  {
    role: "AI/ML Engineer",
    company: "Revvity Health Sciences",
    location: "Waltham, MA",
    period: "Jan – Apr 2025",
    points: [
      "Built Revvity's internal LLM platform in Next.js with file and image uploads, caching, and saved prompts, cutting about 20% off the time spent on common tasks",
      "Connected it to AWS Bedrock and Azure AI agents for retrieval-augmented answers, then containerized the stack and deployed it with CI/CD and monitoring",
    ],
    links: [],
  },
];

export default experiences;
